module.exports = __webpack_public_path__ + "am.1f8cb3f43919f911bcaf.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/am.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/am.svg
// module chunks = styles